export const regions = [
  "Europe",
  "Asia",
  "Africa",
  "Oceania",
  "South America",
  "North America",
];
